import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import { isPatientApp } from '@/config/constants';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: isPatientApp
      ? colors.white
      : colors.newUI.therapist.bgBlue10,
  },
  infoTextStyle: {
    alignSelf: 'center',
    color: colors.darkGrey,
  },
  titleWrapper: {
    marginVertical: theme.spacings.md,
  },
  titleText: {
    textAlign: 'center',
    fontSize: theme.fontSizes.xl,
    color: theme.colors.black,
  },
});
